<template>
  <div id="app">    
    <Mheader/>
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <Mfooter/>

    <div class="fixed-right-wrapper">
      <div class="fixed-box wechat-wrapper">
        <i class="iconfont icon-wechat"></i>
        <span>微信<br/>咨询</span>
        <div class="wechat-box">
          <img class="wechat-code" src="./components/mfooter/wechat-code.png" alt="">
        </div>
      </div>
      <!-- <a class="fixed-box qq" href="http://wpa.qq.com/msgrd?v=3&uin=1002086760&site=qq&menu=yes" target="_blank"> -->
      <a class="fixed-box qq" href="tencent://message/?uin=407454071&Site=qq&Menu=yes" target="_blank">
        <i class="iconfont icon-qq"></i>
        <span>在线<br/>客服</span>
      </a>
    </div>
  </div>
</template>

<script>
import Mheader from '@/components/mheader/mheader'
import Mfooter from '@/components/mfooter/mfooter'

export default {
  name: 'App',
  components: {
    Mheader,
    Mfooter
  }
}
</script>

<style lang="scss" scoped>
#app {
  .fixed-right-wrapper {
    position: fixed;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    z-index: 100;

    width: 50px;
    padding: 10px 0;
    background: rgba(32,160,254, 0.7);
    .fixed-box {
      position: relative;
      display: block;
      width: 50px;
      height: 46px;
      line-height: 36px;
      padding: 5px 0;
      color: #fff;
      text-align: center;

      i{
        font-size: 24px;
      }
      span{
        display: none;
        font-size: 14px;
        line-height: 20px;
      }
      &:hover{
        background-color: #20a0fe;
        i{
          display: none;
        }
        span,.wechat-box{
          display: block;
        }
      }
      .wechat-box {
        display: none;
        position: absolute;
        top: -20px;
        left: -165px;
        width: 65px;
        height: 60px;
        padding: 5px 10px 5px 5px;
        //background: url(./components/mfooter/wechat-code.png) no-repeat;
        background-size: 100% 100%;
        img {
          width: 150px;
          height: 150px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue